import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import UIImage from 'UIComponents/image/UIImage';
import { useAchievementImages } from '../achievementImagesQueries';
export const CertificateBadge = (_ref) => {
  let {
    trackId
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["trackId"]);

  const {
    images: {
      badgeURL
    }
  } = useAchievementImages({
    trackId
  });
  return /*#__PURE__*/_jsx(UIImage, Object.assign({
    "data-category": "badge",
    responsive: true,
    src: badgeURL
  }, props));
};